export const UPDATE_BANNER_TIME = 'UPDATE_BANNER_TIME';
export const updateBannerTime = () => ({ type: UPDATE_BANNER_TIME });
